export default "__VITE_ASSET__DqnNdrTR__"